// extracted by mini-css-extract-plugin
export default {"container":"ModelCarousel__container___dwDGB","navButton":"ModelCarousel__navButton___fgTdl"};